import { Route, Switch } from "react-router-dom";

import HallContentPage from "../../components/page/brand/HallContentPage";
import HomeContentPage from "../../components/page/brand/HomeContentPage";

const BrandPage = () => {
  return (
    <Switch>
      <Route
        exact
        path="/brand/home/content/register"
        component={HomeContentPage}
      />
      <Route path="/brand/hall/content/register" component={HallContentPage} />
    </Switch>
  );
};

export default BrandPage;
